import { Calendar, UserRound, Users } from 'lucide-react';

import { Badge } from '@workspace/shadcn';

import type { ListCourses } from '@workspace/client';

import {
  formatCourseType,
  formatDateRange,
  formatLevel,
} from '../../lib/api.ts';

export type CourseCardData = ListCourses['records'][number];

export function CourseMeta({ course }: { course: CourseCardData }) {
  const trainingMethod = formatCourseType(course.trainingMethod);

  return (
    <div className="mb-6 space-y-3">
      {course.startDate && (
        <div className="text-muted-foreground flex items-center text-sm">
          <Calendar className="me-1 h-4 w-4 shrink-0" />
          <span>{formatDateRange(course.startDate, course.endDate)}</span>
        </div>
      )}

      <div className="text-muted-foreground flex items-center justify-between text-sm">
        {/* The empty span keeps the badge end-anchored when the method is unset. */}
        <span className="flex items-center">
          {trainingMethod && (
            <>
              <Users className="me-1 h-4 w-4 shrink-0" />
              {trainingMethod}
            </>
          )}
        </span>
        <Badge variant="outline">{formatLevel(course.level)}</Badge>
      </div>

      {course.instructorNames.length > 0 && (
        <div className="text-muted-foreground flex items-center text-sm">
          <UserRound className="me-1 h-4 w-4 shrink-0" />
          <span>{course.instructorNames.join(', ')}</span>
        </div>
      )}
    </div>
  );
}
